class StatisticsColumn {
  constructor(container) {
    this.container = container;
    this.statisticItems = container.querySelectorAll(".statistics-column__item");
    this.init();
  }

  init() {
    this.setupObserver();
  }

  setupObserver() {
    Elixir_SeenOnce(this.container, () => this.animateStatistics(), {
      threshold: 0.1,
      rootMargin: "0px 0px -50px 0px",
    });
  }

  animateStatistics() {
    this.statisticItems.forEach((item, index) => {
      setTimeout(() => {
        item.classList.add("animate-in");
        this.animateCounter(item);
      }, index * 100);
    });
  }

  animateCounter(item) {
    const numberEl = item.querySelector("[data-count-to]");
    if (!numberEl) return;

    const target = parseFloat(numberEl.getAttribute("data-count-to"));
    const suffix = numberEl.getAttribute("data-suffix") || "";
    const duration = 2000; // 2 seconds
    const startTime = performance.now();
    const startValue = 0;

    const updateCounter = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);

      // Ease out expo for premium feel
      const easeProgress = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
      const currentValue = startValue + easeProgress * (target - startValue);

      let formattedValue = "";
      if (target % 1 === 0) {
        formattedValue = Math.floor(currentValue).toLocaleString();
      } else {
        formattedValue = currentValue.toFixed(1);
      }
      
      numberEl.textContent = formattedValue + suffix;

      if (progress < 1) {
        requestAnimationFrame(updateCounter);
      } else {
        // Final precise value
        let finalValue = target % 1 === 0 ? target.toLocaleString() : target.toFixed(1);
        numberEl.textContent = finalValue + suffix;
      }
    };

    requestAnimationFrame(updateCounter);
  }
}

// Initialize on DOM load
document.addEventListener("DOMContentLoaded", () => {
  const statisticsColumns = document.querySelectorAll(".statistics-column");
  statisticsColumns.forEach((section) => {
    new StatisticsColumn(section);
  });
});

// Re-initialize for Shopify Theme Editor
document.addEventListener("shopify:section:load", (event) => {
  if (event.target.querySelector(".statistics-column")) {
    new StatisticsColumn(event.target.querySelector(".statistics-column"));
  }
});
